
export default class RGB {
	r: number;
	g: number;
	b: number;

	constructor (r: number, g: number, b: number) {
		this.r = r;
		this.g = g;
		this.b = b;
	}

	setHex (hex: number) {
		this.r = (hex >> 16 & 255) / 255;
		this.g = (hex >> 8  & 255) / 255;
		this.b = (hex       & 255) / 255;
	}

	toString () {
		return 'rgb(' + Math.floor(255 * this.r) + ', ' + Math.floor(255 * this.g) + ', ' + Math.floor(255 * this.b) + ')';
	}
}


// RGB.lerp = function (t, rgb0, rgb1) {
// 	return new RGB(
// 		rgb0.r * (1 - t) + rgb1.r * t,
// 		rgb0.g * (1 - t) + rgb1.g * t,
// 		rgb0.b * (1 - t) + rgb1.b * t
// 	);
// };